import script from "./BooleanInlineEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BooleanInlineEditor.vue?vue&type=script&setup=true&lang=js"

import "./BooleanInlineEditor.vue?vue&type=style&index=0&id=9ea54596&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ea54596"]])

export default __exports__